import { render } from "./editEvents.vue?vue&type=template&id=8fe48608&scoped=true"
import script from "./editEvents.vue?vue&type=script&lang=js"
export * from "./editEvents.vue?vue&type=script&lang=js"

import "./editEvents.vue?vue&type=style&index=0&id=8fe48608&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fe48608"]])

export default __exports__